module.exports = __webpack_public_path__ + "img/code.8a6b27a1.jpg";